import React from 'react';

import {
  BugOutlined,
  CalendarOutlined,
  FileExcelOutlined,
  FileOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { Button, Col, Divider, Input, Modal, Row, Typography } from 'antd';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { DiIngestJobGridMode } from 'models/DiIngestJobGridMode';

import appI18n from '../../../../config/i18n';

interface ErrorDetailModalProps {
  isOpen: boolean;
  handleModalCancel: () => void;
  job: DiIngestJobGridMode;
}

function ErrorDetailModal({
  isOpen,
  handleModalCancel,
  job,
}: ErrorDetailModalProps) {
  const { Text } = Typography;
  const { TextArea } = Input;
  const { t } = useTranslation(undefined, { i18n: appI18n });
  const dateFormat: string = useSelector(
    (state: any) => state.intl?.dateFormat
  );

  // Función para determinar el icono del archivo según su extensión
  const getFileIcon = (filename: string) => {
    const extension = filename.split('.').pop()?.toLowerCase();
    if (extension === 'xlsx' || extension === 'xls') {
      return <FileExcelOutlined style={{ color: '#1890ff' }} />;
    }
    return <FileOutlined style={{ color: '#1890ff' }} />;
  };

  return (
    <Modal
      title={
        <span>
          <BugOutlined />{' '}
          {t(
            'scenes.data_ingester.upload_files_history.components.error_detail_modal.title'
          )}
        </span>
      }
      open={isOpen}
      onCancel={handleModalCancel}
      maskClosable={false}
      destroyOnClose
      footer={null}
      width={650}
    >
      <Divider style={{ marginTop: '15px', marginBottom: '15px' }} />

      <Row gutter={[16, 16]}>
        <Col xs={24}>
          <Text strong style={{ display: 'block', marginBottom: '8px' }}>
            {t(
              'scenes.data_ingester.upload_files_history.components.error_detail_modal.labels.carrier'
            )}
          </Text>
          <Input
            prefix={<UserOutlined style={{ color: '#1890ff' }} />}
            value={job.clientName}
            readOnly
          />
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: '8px' }}>
        <Col xs={24}>
          <Text strong style={{ display: 'block', marginBottom: '8px' }}>
            {t(
              'scenes.data_ingester.upload_files_history.components.error_detail_modal.labels.original_filename'
            )}
          </Text>
          <Input
            prefix={getFileIcon(job.originalFilename)}
            value={job.originalFilename}
            readOnly
          />
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: '8px' }}>
        <Col xs={24}>
          <Text strong style={{ display: 'block', marginBottom: '8px' }}>
            {t(
              'scenes.data_ingester.upload_files_history.components.error_detail_modal.labels.uploaded_at'
            )}
          </Text>
          <Input
            prefix={<CalendarOutlined style={{ color: '#1890ff' }} />}
            value={dayjs(job.createdAt).format(dateFormat)}
            readOnly
          />
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: '16px' }}>
        <Col xs={24}>
          <Text strong style={{ display: 'block', marginBottom: '8px' }}>
            {t(
              'scenes.data_ingester.upload_files_history.components.error_detail_modal.labels.error_detail'
            )}
          </Text>
          <TextArea
            value={job.errorMessage || ''}
            readOnly
            autoSize={{ minRows: 4, maxRows: 10 }}
          />
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: '24px' }}>
        <Col xs={24}>
          <Button type="default" block onClick={handleModalCancel}>
            {t(
              'scenes.data_ingester.upload_files_history.components.error_detail_modal.buttons.close'
            )}
          </Button>
        </Col>
      </Row>
    </Modal>
  );
}

export default ErrorDetailModal;
